import { getClassNames } from '@websolutespa/bom-core';
import style from './message-head.module.scss';

export type MessageHeadProps = {
  name?: string;
  time?: string;
};

export const MessageHead: React.FC<MessageHeadProps> = (props) => {
  return (
    <div className={getClassNames(style.head, 'message__head')}>
      <div className={style.text}>{props.name || 'EFG Chat'}</div>
      {props.time && (
        <div className={style.time}>15:22 PM</div>
      )}
    </div>
  );
};

